import { createApiSaga } from '../../../sagaGenerator';
import { apiGet } from '../../../../middleware/api';
import {
  TSUNAMI_EVENT_SEARCH_REQUEST,
  TSUNAMI_EVENT_SEARCH_SUCCESS,
  TSUNAMI_EVENT_SEARCH_FAILURE,
  TSUNAMI_EVENT_SEARCH_REGION_REQUEST,
  TSUNAMI_EVENT_SEARCH_COUNTRY_REQUEST,
  TSUNAMI_EVENT_SEARCH_AREA_REQUEST,
  TSUNAMI_EVENT_SEARCH_REGION_FAILURE,
  TSUNAMI_EVENT_SEARCH_REGION_SUCCESS,
  TSUNAMI_EVENT_SEARCH_AREA_FAILURE,
  TSUNAMI_EVENT_SEARCH_AREA_SUCCESS,
  TSUNAMI_EVENT_SEARCH_RUNUP_REGION_REQUEST,
  TSUNAMI_EVENT_SEARCH_RUNUP_REGION_FAILURE,
  TSUNAMI_EVENT_SEARCH_RUNUP_REGION_SUCCESS,
  TSUNAMI_EVENT_SEARCH_COUNTRY_FAILURE,
  TSUNAMI_EVENT_SEARCH_COUNTRY_SUCCESS,
  TSUNAMI_EVENT_SEARCH_RUNUP_COUNTRY_REQUEST,
  TSUNAMI_EVENT_SEARCH_RUNUP_AREA_REQUEST,
  TSUNAMI_EVENT_SEARCH_RUNUP_AREA_FAILURE,
  TSUNAMI_EVENT_SEARCH_RUNUP_AREA_SUCCESS,
  TSUNAMI_EVENT_SEARCH_RUNUP_COUNTRY_FAILURE,
  TSUNAMI_EVENT_SEARCH_RUNUP_COUNTRY_SUCCESS,
  TSUNAMI_EVENT_SEARCH_RUNUP_MEASURE_TYPE_FAILURE,
  TSUNAMI_EVENT_SEARCH_RUNUP_MEASURE_TYPE_REQUEST,
  TSUNAMI_EVENT_SEARCH_RUNUP_MEASURE_TYPE_SUCCESS,
  TSUNAMI_EVENT_SEARCH_VALIDITY_REQUEST,
  TSUNAMI_EVENT_SEARCH_VALIDITY_SUCCESS,
  TSUNAMI_EVENT_SEARCH_VALIDITY_FAILURE,
  TSUNAMI_EVENT_SEARCH_CAUSE_REQUEST,
  TSUNAMI_EVENT_SEARCH_CAUSE_SUCCESS,
  TSUNAMI_EVENT_SEARCH_CAUSE_FAILURE,
} from './tsunamiEventSearchReducer';


const searchTsunamiEventsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/tsunamis/events', ...action }),
  requestType: TSUNAMI_EVENT_SEARCH_REQUEST,
  successType: TSUNAMI_EVENT_SEARCH_SUCCESS,
  failureType: TSUNAMI_EVENT_SEARCH_FAILURE,
});

const getRegionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/regions', ...action }),
  requestType: TSUNAMI_EVENT_SEARCH_REGION_REQUEST,
  successType: TSUNAMI_EVENT_SEARCH_REGION_SUCCESS,
  failureType: TSUNAMI_EVENT_SEARCH_REGION_FAILURE,
});

const getCountriesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/countries', ...action }),
  requestType: TSUNAMI_EVENT_SEARCH_COUNTRY_REQUEST,
  successType: TSUNAMI_EVENT_SEARCH_COUNTRY_SUCCESS,
  failureType: TSUNAMI_EVENT_SEARCH_COUNTRY_FAILURE,
});

const getAreasSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/descriptors/tsunami/areas/${action.country}`, ...action }),
  requestType: TSUNAMI_EVENT_SEARCH_AREA_REQUEST,
  successType: TSUNAMI_EVENT_SEARCH_AREA_SUCCESS,
  failureType: TSUNAMI_EVENT_SEARCH_AREA_FAILURE,
});

const getRunupRegionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/runup/regions', ...action }),
  requestType: TSUNAMI_EVENT_SEARCH_RUNUP_REGION_REQUEST,
  successType: TSUNAMI_EVENT_SEARCH_RUNUP_REGION_SUCCESS,
  failureType: TSUNAMI_EVENT_SEARCH_RUNUP_REGION_FAILURE,
});

const getRunupCountriesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/runup/countries', ...action }),
  requestType: TSUNAMI_EVENT_SEARCH_RUNUP_COUNTRY_REQUEST,
  successType: TSUNAMI_EVENT_SEARCH_RUNUP_COUNTRY_SUCCESS,
  failureType: TSUNAMI_EVENT_SEARCH_RUNUP_COUNTRY_FAILURE,
});

const getRunupAreasSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/descriptors/tsunami/runup/areas/${action.country}`, ...action }),
  requestType: TSUNAMI_EVENT_SEARCH_RUNUP_AREA_REQUEST,
  successType: TSUNAMI_EVENT_SEARCH_RUNUP_AREA_SUCCESS,
  failureType: TSUNAMI_EVENT_SEARCH_RUNUP_AREA_FAILURE,
});

const getRunupMeasureTypesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/runup/measurement-types', ...action }),
  requestType: TSUNAMI_EVENT_SEARCH_RUNUP_MEASURE_TYPE_REQUEST,
  successType: TSUNAMI_EVENT_SEARCH_RUNUP_MEASURE_TYPE_SUCCESS,
  failureType: TSUNAMI_EVENT_SEARCH_RUNUP_MEASURE_TYPE_FAILURE,
});

const getValiditySaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/validity', ...action }),
  requestType: TSUNAMI_EVENT_SEARCH_VALIDITY_REQUEST,
  successType: TSUNAMI_EVENT_SEARCH_VALIDITY_SUCCESS,
  failureType: TSUNAMI_EVENT_SEARCH_VALIDITY_FAILURE,
});

const getCauseSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/causes', ...action }),
  requestType: TSUNAMI_EVENT_SEARCH_CAUSE_REQUEST,
  successType: TSUNAMI_EVENT_SEARCH_CAUSE_SUCCESS,
  failureType: TSUNAMI_EVENT_SEARCH_CAUSE_FAILURE,
});

export const searchTsunamiEventsSagas = [
  searchTsunamiEventsSaga,
  getRegionsSaga,
  getCountriesSaga,
  getAreasSaga,
  getRunupRegionsSaga,
  getRunupCountriesSaga,
  getRunupAreasSaga,
  getRunupMeasureTypesSaga,
  getValiditySaga,
  getCauseSaga,
];
